import { c as _c } from "react/compiler-runtime";
import { cn } from "@repo/common/utils/cn";
import { Permanent_Marker } from "next/font/google";
import Image from "next/image";
const permanentMarker = Permanent_Marker({
  weight: "400",
  subsets: ["latin"]
});
export function GuaranteeContent() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <p className={cn("font-serif leading-[1.72] text-lg text-foreground-muted tracking-wide font-semibold self-center whitespace-pre-wrap", permanentMarker.className)}>Our Growth Guarantee ensures your business will grow 10% after your first year using Homeworks or we'll give you your money back!</p>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="self-end w-[250px] mr-3"><Image src="/next-assets/mike-signature.png" alt="Homeworks" width={250} height={139} className="w-full h-full object-contain" /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex flex-col gap-4 -mt-12">{t0}<div className="flex flex-col self-end pr-12">{t1}<div className="self-end text-sm text-[rgba(34,34,34,0.6)] whitespace-nowrap leading-none -mt-4"><div className="flex flex-col gap-2">Mike Andes<div><span>{"Founder, "}</span><span className="font-bold">Homeworks</span></div></div></div></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}